import { render } from "./RolesForUserView.vue?vue&type=template&id=367e2d6a&scoped=true&ts=true"
import script from "./RolesForUserView.vue?vue&type=script&lang=ts"
export * from "./RolesForUserView.vue?vue&type=script&lang=ts"

import "./RolesForUserView.vue?vue&type=style&index=0&id=367e2d6a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367e2d6a"]])

export default __exports__